import {TextInput, TextInputHidden, SquareButton, ForwardsBackwardsBar, HeaderBig, LoadButton} from '../common/Common';
import {useContext, useEffect, useState} from 'react';
import './ResetPassword.css';
import { LocaleContext, LoginContext, StateContext } from '../common/App';
import { postWithCsrf } from '../common/util';
import { useSearchParams } from 'react-router-dom';
import { LoadState } from '../common/enums.mjs';
import { NewPasswordInput } from './Register';
import { useIndexUpdate, useNavigateSmart } from '../common/hooks';

export function ResetPassword(props) {
    const locale = useContext(LocaleContext);
    const state = useContext(StateContext);
    const login = useContext(LoginContext);

    const navigate = useNavigateSmart();
    const [searchParams, setSearchParams] = useSearchParams();  

    const [password, setPassword] = useState("");
    const [passwordConfirmation, setPasswordConfirmation] = useState("");

    const [sendState, setSendState] = useState(LoadState.NONE);

    function resetPassword() {
        try {
            const uidb64 = searchParams.get("uidb64");
            const token = searchParams.get("token");
            
            postWithCsrf("/user/reset_password/" + uidb64 + "/" + token, JSON.stringify({password: password}), state).then(response => {
                if(response.ok) {
                    // setResendText(locale.msgs.RESEND_MAIL_SUCCESS);
                    // setResendTextClass("text_success");
                    setSendState(LoadState.LOAD_SUCCESS);
                    navigate("/login/");
                    return;
                }
                
                throw new Error("Response code: " + response.status);
            }).catch(error => {
                console.log("ERROR: " + error);
                // setResendText(locale.msgs.RESEND_MAIL_ERROR);
                // setResendTextClass("text_error");
                setSendState(LoadState.LOAD_ERROR);
            });

            // Calling setSendState() after postWithCsrf() as it could throw an exception
            setSendState(LoadState.LOADING);
        }
        catch(e) {
            console.log(e);
        }
    }

    function isValid() {
        if(!password) {
            return false;
        }

        if(password === ""){
            return false;
        }

        if(password !== passwordConfirmation){
            return false;
        }

        return true;
    }


    useEffect(() => {
        // const eventSource = new EventSource("/user/is_mail_confirmed_sse");
  // 
        // eventSource.onmessage = function(event) {
        //     // const data = JSON.parse(event.data);
        //     // console.log("Got message: " + data.message);
        //     
        //     navigate("/mail_confirmed/?username=" + login.username);
        // };
// 
        // eventSource.onerror = function(error) {
        //     console.error("EventSource failed:", error);
        //     eventSource.close();
        // };
    }, []);

    useEffect(() => {
        setSendState(LoadState.NONE);
    }, [password, passwordConfirmation]);

    useIndexUpdate(props.indexUpdate, locale);


    // RENDER:

    return (
        <div className="reset_password_box margin_to_header">
            
                { sendState !== LoadState.LOAD_SUCCESS ?
                    <div className="reset_password_content side_padding">
                
                        <div className="head">{locale.msgs.CREATE_NEW_PASSWORD}</div>
                        <div className="text">{locale.msgs.CREATE_NEW_PASSWORD_DESCR}</div>

                        <div className="reset_password_pwd_input">
                            <NewPasswordInput password={password} setPassword={setPassword}
                                    passwordConfirmation={passwordConfirmation} setPasswordConfirmation={setPasswordConfirmation} />
                        </div>

                        <div className="reset_password_btn_box">
                            <div></div>

                            <div>
                                <LoadButton text={locale.msgs.RESET} clickable={isValid()}
                                        onClick={() => resetPassword()}
                                        saving={sendState === LoadState.LOADING}
                                        notSaved={sendState === LoadState.LOAD_ERROR}
                                        errText={locale.msgs.ERROR} />
                            </div>
                        </div>
                    </div>
                :
                    <div className="forgot_password_content side_padding">
                        
                    </div>
                }
        </div>
    );
}
